import { injectIntl } from "react-intl";
import FrontendCookiePolicyIT from "./it";
import "./style.css";

const FrontendCookiePolicy = ({ intl }) => {
   return <FrontendCookiePolicyIT />;
};

export default injectIntl(FrontendCookiePolicy);
